<template>
  <div>
    <!-- Cancel modal -->
    <div class="modal fade" :class="{ show: cancelModal, 'd-block': cancelModal }" tabindex="-1" :style="{ display: cancelModal ? 'block' : 'none' }">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Cancel booking</h5>
            <button type="button" class="btn-close" @click="cancelModal = false"></button>
          </div>
          <div class="modal-body">
            <p class="mb-3">Cancel booking <strong>{{ cancelTarget && cancelTarget.reference }}</strong>?</p>
            <div class="mb-3">
              <label class="form-label">Reason</label>
              <input class="form-control" v-model="cancelReason" placeholder="Reason for cancellation" />
            </div>
            <div class="form-check">
              <input class="form-check-input" type="checkbox" id="cancelnotify" v-model="cancelNotify" />
              <label class="form-check-label" for="cancelnotify">Notify booker by e-mail</label>
            </div>
          </div>
          <div class="modal-footer">
            <button class="btn btn-secondary" @click="cancelModal = false">Close</button>
            <button class="btn btn-danger" @click="confirmCancel">Cancel booking</button>
          </div>
        </div>
      </div>
    </div>
    <div v-if="cancelModal" class="modal-backdrop fade show"></div>

    <Navbar v-if="$route.name === 'bookings'" />
    <!-- <Breadcrumb v-if="$route.name === 'bookings'" /> -->
    <div class="px-3">
      <div class="row mt-3 mb-3">
        <div class="col-8">
          <div class="d-flex flex-nowrap flex-wrap" style="gap: 0.5rem;">
            <button class="btn btn-primary gdq_faded gdq-font-size-80" :disabled="exporting" @click="exportExcel" style="width: 16.66%;">
              <fa-icon name="file-excel" class="me-1" />{{ exporting ? 'Exporting…' : 'Export' }}
            </button>
            <select v-model="filters.event_id" @change="applyFilters" class="form-select gdq-font-size-80" style="width: 20%;">
              <option :value="0">All events</option>
              <option v-for="e in events" :key="e.id" :value="e.id">{{ e.title_en || e.slug }}</option>
            </select>
            <select v-model="filters.status" @change="applyFilters" class="form-select gdq-font-size-80" style="width: 16.66%;">
              <option value="">Status</option>
              <option value="pending">Pending</option>
              <option value="confirmed">Confirmed</option>
              <option value="cancelled">Cancelled</option>
            </select>
            <input type="date" v-model="filters.from" @change="applyFilters" class="form-control gdq-font-size-80" style="width: 12%;" title="From date" />
            <input type="date" v-model="filters.to" @change="applyFilters" class="form-control gdq-font-size-80" style="width: 12%;" title="To date" />
          </div>
        </div>
        <div class="col-4">
          <div class="input-group input-group-sm">
            <input v-model="filters.search" placeholder="Search ref / email / name..." type="text" @input="searchDebounced" class="form-control gdq-font-size-80" autocomplete="off" />
            <button class="btn btn-outline-secondary" type="button" @click="filters.search=''; applyFilters()">X</button>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-12 mb-3 text-start">Number of bookings in the list: {{ total }}</div>
      </div>

      <div class="table-responsive">
        <table class="table table-hover align-middle">
          <thead>
            <tr>
              <th style="width: 40px;"></th>
              <th>Ref</th>
              <th>Event</th>
              <th>First attendee</th>
              <th>Seats</th>
              <th>Status</th>
              <th>Verified</th>
              <th>Created</th>
              <th class="text-end">Actions</th>
            </tr>
          </thead>
          <tbody>
            <template v-for="b in bookings" :key="b.id">
              <tr @click="toggleDetail(b)">
                <td class="text-center">{{ expanded === b.id ? '▾' : '▸' }}</td>
                <td>{{ b.reference }}</td>
                <td>{{ b.event_title || ('#' + b.event_id) }}</td>
                <td>
                  {{ (b.first_attendee_name || '').trim() || '-' }}
                  <div class="text-muted small" v-if="b.first_attendee_email">{{ b.first_attendee_email }}</div>
                </td>
                <td>{{ b.seats }}</td>
                <td><span :class="statusBadge(b.status)" style="font-size: 0.875rem;">{{ capStatus(b.status) }}</span></td>
                <td>{{ b.verified ? 'yes' : 'no' }}</td>
                <td>{{ fmtDate(b.created_at) }}</td>
                <td class="text-end" @click.stop>
                  <button class="btn btn-sm btn-outline-success me-1" v-if="b.status === 'pending'" @click="confirmBooking(b)">Confirm</button>
                  <button class="btn btn-sm btn-outline-primary me-1" v-if="b.status !== 'cancelled' && !b.verified" @click="verifyBooking(b)">Verify</button>
                  <button class="btn btn-sm btn-outline-danger" v-if="b.status !== 'cancelled'" @click="openCancel(b)">Cancel</button>
                </td>
              </tr>
              <tr v-if="expanded === b.id">
                <td colspan="9" class="bg-light">
                  <div class="ms-4 my-3">
                    <h6>Attendees ({{ detail && detail.attendees ? detail.attendees.length : 0 }})</h6>
                    <div v-if="detailLoading" class="spinner-border spinner-border-sm"></div>
                    <table class="table table-sm" v-else-if="detail">
                      <thead>
                        <tr><th>Name</th><th>E-mail</th><th>Custom fields</th></tr>
                      </thead>
                      <tbody>
                        <tr v-for="a in detail.attendees" :key="a.id">
                          <td>{{ a.first_name }} {{ a.last_name }}</td>
                            <td>{{ a.email }}</td>
                          <td>
                            <span class="badge bg-secondary me-1" v-for="(val, key) in flattenData(a.data)" :key="key">{{ key }}: {{ val }}</span>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                    <div class="text-muted small mt-2" v-if="detail && detail.booking.cancel_reason">
                      Cancel reason: {{ detail.booking.cancel_reason }}
                    </div>
                  </div>
                </td>
              </tr>
            </template>
            <tr v-if="!loading && bookings.length === 0">
              <td colspan="9" class="text-center text-muted py-4">No bookings found</td>
            </tr>
          </tbody>
        </table>
      </div>

      <Pagination :current-page="page" :per-page="perPage" :total-rows="total" aria-label="Bookings pagination" @page-changed="goPage" />
    </div>
  </div>
</template>

<script>
import _ from 'lodash';
import Navbar from './Navbar.vue'
// import Breadcrumb from './Breadcrumb.vue'
import Pagination from './Pagination.vue'

export default {
  name: 'Bookings',
  components: { Navbar, Pagination },
  data () {
    return {
      filters: {
        event_id: 0,
        status: '',
        from: '',
        to: '',
        search: ''
      },
      events: [],
      bookings: [],
      total: 0,
      page: 1,
      perPage: 20,
      loading: false,
      expanded: null,
      detail: null,
      detailLoading: false,
      cancelModal: false,
      cancelTarget: null,
      cancelReason: '',
      cancelNotify: true,
      exporting: false
    }
  },
  created () {
    const ev = Number(this.$route.query.event)
    if (ev) this.filters.event_id = ev
    this.events_get()
    this.bookings_get()
  },
  methods: {
    searchDebounced: _.debounce(function () {
      this.applyFilters()
    }, 400),
    applyFilters () {
      this.page = 1
      this.bookings_get()
    },
    goPage (p) {
      if (p < 1) return
      this.page = p
      this.bookings_get()
    },
    async events_get () {
      try {
        const res = await this.$store.dispatch('events_admin_list', { start: 1, limit: 1000 })
        this.events = res.data.result
      } catch (e) { this.events = [] }
    },
    async bookings_get () {
      this.loading = true
      try {
        const res = await this.$store.dispatch('bookings_list', {
          event_id: this.filters.event_id,
          status: this.filters.status,
          from: this.filters.from,
          to: this.filters.to,
          search: this.filters.search,
          start: this.page,
          limit: this.perPage
        })
        this.bookings = res.data.result
        this.total = res.data.total
      } catch (e) {
        this.bookings = []
        this.total = 0
      }
      this.loading = false
    },
    async toggleDetail (b) {
      if (this.expanded === b.id) {
        this.expanded = null
        this.detail = null
        return
      }
      this.expanded = b.id
      this.detail = null
      this.detailLoading = true
      try {
        const res = await this.$store.dispatch('booking_get', { id: b.id })
        this.detail = res.data.result
      } catch (e) {
        this.detail = null
      }
      this.detailLoading = false
    },
    flattenData (data) {
      if (!data) return {}
      const out = {}
      Object.keys(data).forEach(k => {
        const v = data[k]
        out[k] = (v === null || v === undefined) ? '' : (typeof v === 'object' ? JSON.stringify(v) : v)
      })
      return out
    },
    statusBadge (s) {
      const map = {
        pending: 'badge bg-warning text-dark',
        confirmed: 'badge bg-success text-dark',
        cancelled: 'badge bg-danger'
      }
      return map[s] || 'badge bg-light text-dark'
    },
    capStatus (s) {
      return s ? s.charAt(0).toUpperCase() + s.slice(1) : s
    },
    fmtDate (s) {
      if (!s) return ''
      return String(s).replace('T', ' ').substring(0, 16)
    },
    async confirmBooking (b) {
      try {
        await this.$store.dispatch('booking_update', { body: { id: b.id, status: 'confirmed' } })
        this.bookings_get()
      } catch (e) { alert('Confirm failed') }
    },
    async verifyBooking (b) {
      try {
        await this.$store.dispatch('booking_update', { body: { id: b.id, verified: true } })
        this.bookings_get()
      } catch (e) { alert('Verify failed') }
    },
    openCancel (b) {
      this.cancelTarget = b
      this.cancelReason = ''
      this.cancelNotify = true
      this.cancelModal = true
    },
    async confirmCancel () {
      try {
        await this.$store.dispatch('booking_update', {
          body: {
            id: this.cancelTarget.id,
            status: 'cancelled',
            cancel_reason: this.cancelReason,
            notify: this.cancelNotify
          }
        })
        this.cancelModal = false
        this.bookings_get()
      } catch (e) { alert('Cancel failed') }
    },
    async exportExcel () {
      this.exporting = true
      try {
        const blob = await this.$store.dispatch('bookings_excel', {
          event_id: this.filters.event_id,
          status: this.filters.status,
          from: this.filters.from,
          to: this.filters.to,
          search: this.filters.search
        })
        const url = window.URL.createObjectURL(new Blob([blob]))
        const a = document.createElement('a')
        a.href = url
        a.download = 'event-bookings.xlsx'
        document.body.appendChild(a)
        a.click()
        document.body.removeChild(a)
        window.URL.revokeObjectURL(url)
      } catch (e) {
        alert('Export failed')
      }
      this.exporting = false
    }
  }
}
</script>
